import { combineReducers } from 'redux';

import union from 'lodash/union';
import * as types from '../../types';

const byId = (state = {}, action) => {
  switch (action.type) {
    //TYPES COMPLETED IMPORT
    case types.JOBS_BACKLOG_IMPORT_COMPLETED: {
      const { entities, order } = action.payload;
      const newState = {};
      order.forEach((id) => {
        newState[id] = {
          isSelected: false,
          isShownInMap: false,
          ...state[id],
          ...entities[id],
          isConfirmed: true
        };
      });
      return newState;
    }

    //DEFAULT
    default: {
      return state;
    }
  }
};

const order = (state = [], action) => {
  switch (action.type) {
    //CASE COMPLETED IMPORT
    case types.JOBS_BACKLOG_IMPORT_COMPLETED: {
      const { order } = action.payload;
      return union(order);
    }

    //DEFAULT
    default: {
      return state;
    }
  }
};

const isImporting = (state = false, action) => {
  switch (action.type) {
    case types.JOBS_BACKLOG_IMPORT_STARTED: {
      return true;
    }
    case types.JOBS_BACKLOG_IMPORT_COMPLETED:
    case types.JOBS_BACKLOG_IMPORT_FAILED: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const errorImporting = (state = null, action) => {
  switch (action.type) {
    case types.JOBS_BACKLOG_IMPORT_FAILED: {
      const { error } = action.payload;
      return error;
    }
    case types.JOBS_BACKLOG_IMPORT_STARTED:
    case types.JOBS_BACKLOG_IMPORT_COMPLETED: {
      return null;
    }
    default: {
      return state;
    }
  }
};

const importedJobs = combineReducers({
  byId,
  order,
  isImporting,
  errorImporting
});

export default importedJobs;

//Own state
export const getOwnState = (state) => state.jobs.jobsBacklog.importedJobs;

//Information
export const getJob = (state, id) => getOwnState(state).byId[id];

export const getJobsList = (state) => getOwnState(state).order.map((id) => getJob(state, id));

//Status of sagas
export const isImportingJobs = (state) => getOwnState(state).isImporting;

//Errors
export const getImportingJobsErrors = (state) => getOwnState(state).errorImporting;
